"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonDateFilter = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const Form_1 = require("../Form");
function isoDate(date) {
    const year = String(date.getFullYear());
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
}
function todayRange() {
    const today = isoDate(new Date());
    return { preset: 'Diário', start: today, end: today };
}
function weekRange() {
    const today = new Date();
    const weekday = today.getDay();
    const start = new Date(today);
    start.setDate(today.getDate() - weekday);
    const end = new Date(today);
    end.setDate(today.getDate() + (6 - weekday));
    return {
        preset: 'Semanal',
        start: isoDate(start),
        end: isoDate(end),
    };
}
function monthRange() {
    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return {
        preset: 'Mensal',
        start: isoDate(start),
        end: isoDate(end),
    };
}
function yearRange() {
    const year = new Date().getFullYear();
    return {
        preset: 'Anual',
        start: isoDate(new Date(year, 0, 1)),
        end: isoDate(new Date(year, 11, 31)),
    };
}
const OktonDateFilter = ({ value, onChange, isDisabled, }) => {
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    const [custom, setCustom] = react_2.default.useState({
        start: value.start,
        end: value.end,
    });
    react_2.default.useEffect(() => {
        if (value.preset === 'Personalizado') {
            setCustom({ start: value.start, end: value.end });
        }
    }, [value.preset, value.start, value.end]);
    const presets = [
        { label: 'Diário', resolve: todayRange },
        { label: 'Semanal', resolve: weekRange },
        { label: 'Mensal', resolve: monthRange },
        { label: 'Anual', resolve: yearRange },
    ];
    return (react_2.default.createElement(react_1.Flex, { borderWidth: "1px", p: "2", rounded: "xl", bg: bg, overflowX: "auto" },
        react_2.default.createElement(react_1.HStack, { spacing: "2" },
            react_2.default.createElement(react_1.Menu, null,
                react_2.default.createElement(react_1.MenuButton, { as: react_1.Button, variant: value.preset === 'Personalizado'
                        ? 'solid'
                        : 'outline', isDisabled: isDisabled, "aria-label": "Selecionar per\u00EDodo personalizado" }, react_2.default.createElement(lu_1.LuCalendarDays)),
                react_2.default.createElement(react_1.MenuList, { p: "3", minW: "360px" },
                    react_2.default.createElement(react_1.Flex, { justify: "space-between", align: "center", mb: "3", gap: "3" },
                        react_2.default.createElement(react_1.Text, { fontWeight: "600" }, "Per\u00EDodo personalizado"),
                        react_2.default.createElement(react_1.Button, { size: "sm", colorScheme: "blue", onClick: () => onChange({
                                preset: 'Personalizado',
                                start: custom.start,
                                end: custom.end,
                            }), isDisabled: !custom.start || !custom.end }, "Aplicar")),
                    react_2.default.createElement(react_1.Flex, { gap: "3" },
                        react_2.default.createElement(Form_1.OktonInput, { name: "okton-period-start", type: "date", value: custom.start, onChange: event => setCustom(current => (Object.assign(Object.assign({}, current), { start: event.target.value }))) }),
                        react_2.default.createElement(Form_1.OktonInput, { name: "okton-period-end", type: "date", value: custom.end, onChange: event => setCustom(current => (Object.assign(Object.assign({}, current), { end: event.target.value }))) })))),
            presets.map(item => (react_2.default.createElement(react_1.Button, { key: item.label, variant: value.preset === item.label
                    ? 'solid'
                    : 'outline', isDisabled: isDisabled, onClick: () => onChange(item.resolve()) }, item.label))))));
};
exports.OktonDateFilter = OktonDateFilter;
//# sourceMappingURL=DateFilter.js.map